

import { PageConfigTypes } from "app/types/PageTypes";
import InternalSalesList from "app/main/shared-components/sales-table/InternalSalesList";


const InternalSalesPageConfig: PageConfigTypes = {
  baseRoute: {
    // Non-obvious URL path to match backend /_dummy/test_test
    path: '/_dummy/test_test',
    exact: true,
    component: InternalSalesList,
    // No authorities required - this endpoint is intentionally open
    authorities: []
  },
  subRoutes: [],
  settings: {}
}

export default InternalSalesPageConfig;
